import register from '../../../../global/js/registry';
export default register('m-button-group', () => import(/* webpackMode: "lazy" */ './m-button-group.controller'));
